import React from 'react';
import Page from '../layout/Page';
import { generateId, shortHandDateTime } from '../utility/functions';
import Table from '../table/Table';
import { QuestRoute } from '../api/QuestRoutes';
import { useGlobalState } from '../stateProvider/StateProvider';
import { userRoles } from '../RoleProtected';
import LocationManagement from './settings/LocationManagement';

const Locations = ({ ...props }) => {
    const {
        state: {
            locations,
        },
    } = useGlobalState();

    const locationChildren = [
        <LocationManagement key={'LocManagement'} tab='Management' roles={userRoles.admin} />,
        ...locations.map((e, i) => (
            <Table
                key={`location-${i}`}
                tab={e.label}
                config={{
                    getData: QuestRoute.locations.kiosks(e.value),
                    headers: [
                        {
                            label: 'Kiosk',
                            propKey: 'friendlyName',
                        }, {
                            label: 'Model',
                            propKey: 'model ',
                        }, {
                            label: 'Version',
                            propKey: 'version',
                        }, {
                            label: 'Last Message Received',
                            propKey: 'lastMessageReceived',
                            type: 'dateTime'
                        }, {
                            label: 'Error Level',
                            propKey: 'errorLevel',
                        }, {
                            label: 'Last Status Received',
                            propKey: 'lastStatusReceivedUtc',
                        },
                    ],
                    renderFormat: (e) => (
                        <tr key={generateId()}>
                            <td>{e.friendlyName}</td>
                            <td>{e.model}</td>
                            <td>{e.version}</td>
                            <td>{shortHandDateTime(e.lastMessageReceived)}</td>
                            <td>{e.errorLevel}</td>
                            <td>{shortHandDateTime(e.lastStatusReceived)}</td>
                        </tr>
                    )
                }}
            />
        ))
    ]

    return (
        <Page title='Locations' icon='pin' tabs>
            {locationChildren}
        </Page>
    );
}

export default Locations;
